import BaseInputNumber from 'components/atoms/base-input-number';
import PropTypes from 'prop-types';

const NumberInput = ({
  id,
  title,
  setValue,
  values,
  isRequired,
  disabled,
  requiredIf,
  helpText,
  placeholder,
}) => {
  let required = isRequired;
  if (requiredIf) {
    required = isRequired || values[requiredIf.key] === requiredIf.value;
  }

  return (
    <div className="input-wrapper" data-cy={id}>
      <label htmlFor={id}>
        {title} {required && <span className="color-red">*</span>}
      </label>
      {helpText && <p className="help-text">{helpText}</p>}
      <BaseInputNumber
        id={id}
        disabled={disabled}
        placeholder={placeholder}
        value={values[id] || ''}
        onChange={(v) => {
          setValue({ [id]: v });
        }}
        controls={false}
      />
    </div>
  );
};

NumberInput.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  helpText: PropTypes.string,
  setValue: PropTypes.func,
  isRequired: PropTypes.bool,
  requiredIf: PropTypes.object,
  disabled: PropTypes.bool,
  values: PropTypes.shape(),
  placeholder: PropTypes.string,
};

export default NumberInput;
